import I18n from 'components/I18n'
import { CounterMoney } from 'components/PairMoney'
import messages from 'lang'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

const StatsWrapper = styled.div<{ isPositive: boolean }>`
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;

  > :first-child {
    color: ${color('white')};
    margin: 0;
  }

  > :nth-child(2) {
    color: ${(p) => (p.isPositive ? color('green400') : color('red400'))};
    margin: 0;

    small {
      color: ${color('dark200')};
      font-size: 100%;
    }
  }
`

const Stats = ({ currency, tickerData }) => {
  if (!tickerData || !tickerData.last_trade_price || Number(tickerData.last_trade_price) < 0)
    return null
  const { last_trade_price: price, price_24h } = tickerData
  const isPositive = Number(price) > price_24h
  return (
    <StatsWrapper isPositive={isPositive}>
      <p>
        1 {currency} = <CounterMoney amount={Number(price)} pair={`${currency}-USD`} />
      </p>
      {price_24h > 0 ? (
        <p>
          {isPositive && <>+</>}
          <CounterMoney amount={price} pair={`${currency}-USD`} />{' '}
          <FormattedNumber
            maximumFractionDigits={2}
            minimumFractionDigits={2}
            value={((Number(price) - Number(price_24h)) * 100) / price_24h}
          />
          %{' '}
          <small>
            <I18n data={messages.today} />
          </small>
        </p>
      ) : null}
    </StatsWrapper>
  )
}

export default Stats
